import { css } from 'linaria';

export const onelineLayout = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: var(--space-200);
`;
